import AwardBadgeIcon from "@/assets/colorable/award_badge.svg?react";
import BankCardIcon from "@/assets/colorable/bank_card.svg?react";
import DocumentIcon from "@/assets/colorable/document.svg?react";
import LockIcon from "@/assets/colorable/lock.svg?react";
import ToolsIcon from "@/assets/colorable/tools.svg?react";
import UserIcon from "@/assets/colorable/user.svg?react";
import UsersIcon from "@/assets/colorable/users.svg?react";
import type {TSettingsSection} from "@/store/types";
import {Sun} from "lucide-react";
import type {FunctionComponent, SVGProps} from "react";
import {useTranslation} from "react-i18next";

export const useSettingsSectionItems = (): Record<
  TSettingsSection,
  {icon: FunctionComponent<SVGProps<SVGSVGElement>>; label: string}
> => {
  const {t} = useTranslation(["common", "settings"]);

  return {
    account_password: {icon: LockIcon, label: t("common:Password")},
    account_preferences: {icon: Sun, label: t("common:Preferences")},
    account_profile: {icon: UserIcon, label: t("settings:profile")},
    admin_billing: {icon: BankCardIcon, label: t("settings:billing")},
    admin_settings: {icon: ToolsIcon, label: t("settings:settings")},
    ambassadors: {icon: AwardBadgeIcon, label: t("settings:ambassadors")},
    billing: {icon: BankCardIcon, label: t("settings:billing")},
    info: {icon: DocumentIcon, label: t("settings:info")},
    users: {icon: UsersIcon, label: t("common:users")},
  };
};
